import $ from 'jquery';

$('.accordion').find('.accordion__element').on('click', function () {
    var $content = $(this).find('.accordion__content-wrap');
    if ($content.length > 0 && !$(this).hasClass('opened')) {
        $('.accordion__element').removeClass('opened');
        $(this).addClass('opened');
    } else {
        $(this).removeClass('opened');
    }
});

$('.accordion__content').on('click', function (e) {
    e.stopPropagation();
});
